import {countryCurrencyEnum} from './kp11-utility'

/**
 * Filters items based on whether they support the selected country's currency
 * @param {Array} items - Array of items (centers, apps, or fees)
 * @param {string} selectedCountry - ISO country code (e.g., 'US', 'AU', 'CA', 'NZ')
 * @returns {Array} - Filtered items that support the selected country
 */
export const filterItemsByCountry = (items = [], selectedCountry = 'US') => {
  if (!Array.isArray(items) || !selectedCountry) return items

  const targetCurrency = countryCurrencyEnum[selectedCountry]
  if (!targetCurrency) return items

  return items.reduce((acc, item) => {
    // Check if item has currencies array and contains the target currency
    if (Array.isArray(item.currencies)) {
      const hasCurrency = item.currencies.some(
        c => c.currency === targetCurrency,
      )

      // Hide the product if the selected country's currency is not available
      if (!hasCurrency) return acc

      acc.push({
        ...item,
        currency: targetCurrency,
        entitlements: Array.isArray(item.entitlements)
          ? item.entitlements.map(ent => ({
              ...ent,
              currency: targetCurrency,
            }))
          : item.entitlements,
        addons: Array.isArray(item.addons)
          ? item.addons.map(addon => ({
              ...addon,
              currency: targetCurrency,
            }))
          : item.addons,
      })

      return acc
    }

    acc.push({
      ...item,
      currency: targetCurrency,
      entitlements: Array.isArray(item.entitlements)
        ? item.entitlements.map(ent => ({
            ...ent,
            currency: targetCurrency,
          }))
        : item.entitlements,
      addons: Array.isArray(item.addons)
        ? item.addons.map(addon => ({
            ...addon,
            currency: targetCurrency,
          }))
        : item.addons,
    })

    return acc
  }, [])
}

/**
 * Filters centers and apps data by country before building groups
 * @param {Object} centersAndApps - Object with centers, apps, oneTimeFees arrays
 * @param {string} selectedCountry - ISO country code
 * @returns {Object} - Filtered centersAndApps object
 */
export const filterCentersAndAppsByCountry = (
  centersAndApps = {},
  selectedCountry = 'US',
) => {
  return {
    centers: filterItemsByCountry(
      centersAndApps.centers || [],
      selectedCountry,
    ),
    apps: filterItemsByCountry(centersAndApps.apps || [], selectedCountry),
    oneTimeFees: filterItemsByCountry(
      centersAndApps.oneTimeFees || [],
      selectedCountry,
    ),
  }
}
